/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import qs from 'qs';
import axios from 'axios';

// initial state
const state = {
  banners: null,
  mainBanner: null,
  loaders: {
    banners: false,
  },
};

// getters
const getters = {
  user_id: (state, getters, rootState, rootGetters) => rootGetters['auth/user'].userInfo.id,
  fuelEmployee: (state, getters, rootState, rootGetters) => rootGetters['main/fuelEmployee'],
  mainBanner: (state) => state.mainBanner,
  banners: (state) => state.banners,
  loaders: (state) => state.loaders,
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  getBanners({ commit }) {
    commit('TOGGLE_LOADING', { key: 'banners', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/news-banners/getBanners/`)
      .then(({ data }) => {
        // Don't do this if not using large top banner
        commit('SET_PROPERTY', { key: 'mainBanner', value: data.shift() });
        commit('SET_PROPERTY', { key: 'banners', value: data });
      })
      .catch(() => {})
      .finally(() => {
        commit('TOGGLE_LOADING', { key: 'banners', value: false });
      });
  },

  recordClick({ commit, getters }, payload) {
    if (!getters.fuelEmployee) {
      return axios.post(`${CONFIG.get('BASE_URL')}/api/news-banners/recordClick/`, qs.stringify({
        banner_id: payload.banner_id,
        user_id: getters.user_id,
      }));
    }
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
